var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-gray-600 w-full md:w-auto"
  }, [_c('div', {
    staticClass: "cursor-pointer inline-block w-max"
  }, [_c('icon', {
    staticClass: "comment-input",
    attrs: {
      "id": _vm.name,
      "name": "message-circle"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "relative"
  }, [_c('textarea', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.show,
      expression: "show"
    }, {
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.forceHide,
      expression: "forceHide"
    }],
    staticClass: "comment-text absolute z-20 top-0 right-0 w-full md:w-auto bg-white py-4 px-5 rounded-lg shadow-md shadow-gray-600 text-base focus:outline-none focus:shadow-outline-indigo focus:border-indigo-300 border-opacity-50",
    class: {
      'text-teal-600': _vm.value.action === 'added',
      'text-indigo-600': _vm.value.action === 'updated',
      'text-pink-600': _vm.value.action === 'deleted',
      'text-gray-600': _vm.value.action === 'none'
    },
    attrs: {
      "rows": "9",
      "cols": "40"
    },
    domProps: {
      "value": _vm.valueAsStr
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }